import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('Role-index-1992f2b8b68cc7e41-1'),
    routerUrl: '/Role',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./Role')),
    children: [
      {
        needLogin: true,
        resourceName: i18n.t('Role-index-1992f2b8b68cc7e41-2'),
        routerUrl: '/RoleForm',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./RoleForm')),
      },
      //$MORE$
    ],
  },
];
